import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { LoginPage } from 'pages/LoginPage';
import { rootStore } from 'stores/RootStore';

type RouteGuardProps = {
  fallbackPage?: React.ReactElement;
  children: React.ReactElement;
};

const RouteGuard = ({
  fallbackPage = <LoginPage />,
  children,
}: RouteGuardProps) => {
  const { isAuthorized } = rootStore.userStore;

  if (!isAuthorized) {
    return fallbackPage;
  }

  return children;
};

export default observer(RouteGuard);
